{
  "Target1Label": "Doel 1:",
  "Target1Placeholder": "15",
  "Target2Label": "Doel 2:",
  "Target2Placeholder": "30",
  "Target3Label": "Doel 3:",
  "Target3Placeholder": "60",
  "Target4Label": "Doel 4:",
  "Target4Placeholder": "90",
  "Target5Label": "Doel 5:",
  "Target5Placeholder": "120",
  "Target6Label": "Doel 6:",
  "Target6Placeholder": "300",
  "TargetUnit": "s",
  "ResetanswertargetsButtonLabel": "Antwoorddoelen resetten",
  "ResetanswertargetsPrompt": "Weet u zeker dat u alle 6 instellingen voor de duur van de beantwoording van inkomende oproepen wilt terugzetten naar hun standaardwaarden?",
  "ResetanswertargetsPromptButtonConfirmLabel": "Bevestigen",
  "ResetanswertargetsPromptButtonCancelLabel": "Annuleren",
  "AnswerPerformance_SectionHeader": "Antwoordprestaties",
  "AnswerPerformance_SectionPara": "U kunt ook specifiek de drempel(s) voor de antwoordduur van het antwoord aanpassen, die worden gebruikt door de zeven varianten van prestatiestatistieken in de stijl \"Beantwoord < = Xs\".",
  "NAME": "AnswerPerformance"
}